/**
 * 创建路由
 */

import Vue from 'vue'
import Router from 'vue-router'

import Login from '@/views/Profile/Login'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_WEB_PATH,
  routes: [{
    name: 'Login',
    path: '/login',
    component: Login
  }]
})



// WEBPACK FOOTER //
// ./src/router/index.js